$(document).ready(function () {

    var storageKey = 'collection_modal_closed';
    var twoHours = 2 * 60 * 60 * 1000;
    var thirtySeconds = 30 * 1000;

    function showModal() {
        $('html').addClass('collection_modal_active');
    }

    function checkModal() {

        var closedTime = localStorage.getItem(storageKey);

        // First visit - show modal after 30 seconds
        if (!closedTime) {
            setTimeout(function () {
                showModal();
            }, thirtySeconds);

            return;
        }

        var timePassed = Date.now() - parseInt(closedTime);

        // 2 hours completed
        if (timePassed >= twoHours) {

            // Clear localStorage
            localStorage.removeItem(storageKey);

            // Show modal after 30 seconds
            setTimeout(function () {
                showModal();
            }, thirtySeconds);

        } else {

            // Still within 2 hours - don't show modal
            var remainingTime = twoHours - timePassed;

            // After remaining 2 hours, clear storage and show modal
            setTimeout(function () {

                localStorage.removeItem(storageKey);

                // Show modal after 30 seconds
                setTimeout(function () {
                    showModal();
                }, thirtySeconds);

            }, remainingTime);
        }
    }

    // Check on site load
    checkModal();


    // Close modal
    $(".new_collection_modal .modal_content .close_icon, .new_collection_modal .custom_overlay").on("click", function () {

        $('html').removeClass('collection_modal_active');

        // Save current time when modal is closed
        localStorage.setItem(storageKey, Date.now());

    });

});

$(function() {
  
  $('.gift_faqs .acc__title').click(function(j) {
    
    var dropDown = $(this).closest('.acc__card').find('.acc__panel');
    $(this).closest('.acc').find('.acc__panel').not(dropDown).slideUp();
    
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).closest('.acc').find('.acc__title.active').removeClass('active');
      $(this).addClass('active');
    }
    
    dropDown.stop(false, true).slideToggle();
    j.preventDefault();
  });
  
  $('.product_acc__title').on('click', function (e) {
    e.preventDefault();

    var $title = $(this);
    var $card = $title.closest('.product_acc__card');
    var $panel = $card.find('.product_acc__panel');

    // Close all other panels
    $('.product_acc__panel').not($panel).slideUp();
    $('.product_acc__title').not($title).removeClass('active');

    // Toggle current panel
    $title.toggleClass('active');
    $panel.stop(true, true).slideToggle();
  });

  $('.request_bulk_quote_button').click(function(j) {
    j.preventDefault();
    $('body').addClass('request_bulk_quote_open');
  });
  $('.request_bulk_quote_popup .close_btn button, .request_bulk_quote_popup .request_bulk_quote_overlay').click(function(j) {
    $('body').removeClass('request_bulk_quote_open');
  });

});

// dropdown open hover
$(document).ready(function () {
  if ($(window).width() > 989.98) {

    $('header-menu details').hover(
      function () {
        $(this).attr('open', true);
        $(this).find('.header__menu-item').attr('aria-expanded', 'true');
      },
      function () {
        $(this).removeAttr('open');
        $(this).find('.header__menu-item').attr('aria-expanded', 'false');
      }
    );
  }
});
// end dropdown open hover

$(document).ready(function(){
    $('.hero_banner_slider .inner_banner_slider').slick({
      arrows: true,
      dots: true,
      prevArrow: `<div class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
      <g fill="rgba(245,245,245,0)" stroke="#e0e0e0" stroke-width="1">
        <circle cx="27" cy="27" r="27"></circle>
        <circle cx="27" cy="27" r="26.5" fill="none"></circle>
      </g>
      <path d="M21.716,23.732,23.7,21.723l-8.507-8.507L23.7,4.709,21.716,2.7,11.2,13.216Z"
            transform="translate(8.55 13.785)"
            fill="#464646"></path>
    </svg></div>`,
      nextArrow: `<div class="slick-arrow slick-next"><svg id="Group_4480" xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
      <g fill="rgba(245,245,245,0)" stroke="#e0e0e0" stroke-width="1">
        <circle cx="27" cy="27" r="27"></circle>
        <circle cx="27" cy="27" r="26.5" fill="none"></circle>
      </g>
      <path d="M21.716,23.732,23.7,21.723l-8.507-8.507L23.7,4.709,21.716,2.7,11.2,13.216Z"
            transform="translate(8.55 13.785) scale(-1,1) translate(-34,0)"
            fill="#464646"></path>
    </svg></div>`,
    });
});

$(document).ready(function(){
  $('.custom_slider_carousel .inner_slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: `<div class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
      <g fill="rgba(245,245,245,0)" stroke="#e0e0e0" stroke-width="1">
        <circle cx="27" cy="27" r="27"></circle>
        <circle cx="27" cy="27" r="26.5" fill="none"></circle>
      </g>
      <path d="M21.716,23.732,23.7,21.723l-8.507-8.507L23.7,4.709,21.716,2.7,11.2,13.216Z"
            transform="translate(8.55 13.785)"
            fill="#464646"></path>
    </svg></div>`,
      nextArrow: `<div class="slick-arrow slick-next"><svg id="Group_4480" xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
      <g fill="rgba(245,245,245,0)" stroke="#e0e0e0" stroke-width="1">
        <circle cx="27" cy="27" r="27"></circle>
        <circle cx="27" cy="27" r="26.5" fill="none"></circle>
      </g>
      <path d="M21.716,23.732,23.7,21.723l-8.507-8.507L23.7,4.709,21.716,2.7,11.2,13.216Z"
            transform="translate(8.55 13.785) scale(-1,1) translate(-34,0)"
            fill="#464646"></path>
    </svg></div>`,
    responsive: [
      {
        breakpoint: 1199.98,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 991.98,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767.98,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.custom_before_after .before_after_slider').slick({
    centerMode: true,
    centerPadding: '50px',
    slidesToShow: 3,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: `<div class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
      <g fill="rgba(245,245,245,0)" stroke="#e0e0e0" stroke-width="1">
        <circle cx="27" cy="27" r="27"></circle>
        <circle cx="27" cy="27" r="26.5" fill="none"></circle>
      </g>
      <path d="M21.716,23.732,23.7,21.723l-8.507-8.507L23.7,4.709,21.716,2.7,11.2,13.216Z"
            transform="translate(8.55 13.785)"
            fill="#464646"></path>
    </svg></div>`,
      nextArrow: `<div class="slick-arrow slick-next"><svg id="Group_4480" xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
      <g fill="rgba(245,245,245,0)" stroke="#e0e0e0" stroke-width="1">
        <circle cx="27" cy="27" r="27"></circle>
        <circle cx="27" cy="27" r="26.5" fill="none"></circle>
      </g>
      <path d="M21.716,23.732,23.7,21.723l-8.507-8.507L23.7,4.709,21.716,2.7,11.2,13.216Z"
            transform="translate(8.55 13.785) scale(-1,1) translate(-34,0)"
            fill="#464646"></path>
    </svg></div>`,
    responsive: [
      {
        breakpoint: 991.98,
        settings: {
          centerPadding: '40px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767.98,
        settings: {
          centerPadding: '30px',
          slidesToShow: 1
        }
      }
    ]
  });

  $('.custom_product_carousel .product_carousel_slider').slick({
    slidesToShow: 3,
    dots: true,
    autoplay: false,
    autoplaySpeed: 2000,
    prevArrow: `<div class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
      <g fill="rgba(245,245,245,0)" stroke="#e0e0e0" stroke-width="1">
        <circle cx="27" cy="27" r="27"></circle>
        <circle cx="27" cy="27" r="26.5" fill="none"></circle>
      </g>
      <path d="M21.716,23.732,23.7,21.723l-8.507-8.507L23.7,4.709,21.716,2.7,11.2,13.216Z"
            transform="translate(8.55 13.785)"
            fill="#464646"></path>
    </svg></div>`,
      nextArrow: `<div class="slick-arrow slick-next"><svg id="Group_4480" xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54">
      <g fill="rgba(245,245,245,0)" stroke="#e0e0e0" stroke-width="1">
        <circle cx="27" cy="27" r="27"></circle>
        <circle cx="27" cy="27" r="26.5" fill="none"></circle>
      </g>
      <path d="M21.716,23.732,23.7,21.723l-8.507-8.507L23.7,4.709,21.716,2.7,11.2,13.216Z"
            transform="translate(8.55 13.785) scale(-1,1) translate(-34,0)"
            fill="#464646"></path>
    </svg></div>`,
    responsive: [
      {
        breakpoint: 991.98,
        settings: {
          centerPadding: '40px',
          slidesToShow: 2
        }
      },
      {
        breakpoint: 767.98,
        settings: {
          centerPadding: '30px',
          slidesToShow: 1
        }
      }
    ]
  });

});

$(document).ready(function () {
    $(".main_acne_removal_page .content_section button.concern-read-more-btn").on("click", function () {
        $(".main_acne_removal_page .content_section").toggleClass("expanded");
        // Change button text
        if ($(".main_acne_removal_page .content_section").hasClass("expanded")) {
            $(this).text("Read Less");
        } else {
            $(this).text("Read More");
        }
    });
    $(".custom_rich_text_editor button.product-read-more-btn").on("click", function () {
        $(".custom_rich_text_editor").toggleClass("expanded");
        // Change button text
        if ($(".custom_rich_text_editor").hasClass("expanded")) {
            $(this).text("Read Less");
        } else {
            $(this).text("Read More");
        }
    });
    $(".product_acc__card .product_acc__panel button.read-more-btn").on("click", function () {
        $(this).parent().toggleClass("expanded");
        // Change button text
        if ($(this).parent().hasClass("expanded")) {
            $(this).text("Read Less");
        } else {
            $(this).text("Read More");
        }
    });
});

